import {enableProdMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from '@app/app.component';
import {APP_CONFIG} from '@app/config/AppConfig';
import {DCP_API_CONFIG} from '@app/config/DcpApiConfig';
import {setFetchDefaultLanguage} from '@ui5/webcomponents-base/dist/config/Language.js';
import {merge} from 'lodash-es';
import {environment} from './environments/environment';
import {appConfig} from './app/app.config';
import '@luigi-project/container';

if (environment.production) {
  enableProdMode();
}

setFetchDefaultLanguage(false);

const IAS_IDP_ACTIVE_FLAG: string = 'iasActiveFlag';
const IAS_NAMESPACE: string = 'iasNamespace';

const bootstrap = () => {
  Promise.all([fetch('/config.common.json'), fetch('/config.routing.json'), fetch('/config.env.json')])
    .then(([commonConfig, routingConfig, envConfig]) => {
      return Promise.all([commonConfig.json(), routingConfig.json(), envConfig.json()]);
    })
    .then(([commonConfig, routingConfig, envConfig]) => {
      // Retrieve the flag from sessionStorage
      let isIasActive = window.sessionStorage.getItem(IAS_IDP_ACTIVE_FLAG);
      let iasNamespace = window.sessionStorage.getItem(IAS_NAMESPACE);

      // Check if the flag is not already set to 'true'
      if (isIasActive !== 'true') {
        // Parse the URL query parameters
        const urlParams = new URLSearchParams(window.location.search);

        const namespaceParam = urlParams.get('namespace');
        isIasActive = namespaceParam ? 'true' : 'false';
        iasNamespace = namespaceParam
          ? namespaceParam.toUpperCase() === 'UDEX'
            ? 'UDEX-US'
            : namespaceParam.toUpperCase()
          : '';

        // If the flag is set to 'true', update sessionStorage
        if (isIasActive === 'true') {
          window.sessionStorage.setItem(IAS_IDP_ACTIVE_FLAG, 'true');
          window.sessionStorage.setItem(IAS_NAMESPACE, iasNamespace);
        }
      }

      // If the flag is set to 'true', extend the authentication configuration
      if (isIasActive === 'true') {
        commonConfig.authentication = {
          ...commonConfig.authentication, // Spread the existing authentication configuration
          ...commonConfig[`authentication${iasNamespace}`], // Spread the IAS-specific authentication configuration
        };

        // same with envConfig
        envConfig.authentication = {
          ...envConfig.authentication,
          ...envConfig[`authentication${iasNamespace}`],
        };
      }
      const config = merge(commonConfig, envConfig, routingConfig, DCP_API_CONFIG);
      bootstrapApplication(AppComponent, {
        ...appConfig,
        providers: [...appConfig.providers, {provide: APP_CONFIG, useValue: config}],
      }).catch((err) => console.error(err)); // NOSONAR
    });
};

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
